module.exports = __webpack_public_path__ + "static/media/img-grow-product-3.82c8fe53.png";